export default __webpack_public_path__ + "static/media/checkmark-high.0c6586bb.svg";